import {getApps, initializeApp} from 'firebase/app';

const appName = 'homehub';

// homehub-XXXではなくbitlock-XXXにしないとIDTokenのAudienceが合わない
// 全部homehub-backendに統一できると楽だけど、管理画面とかと合わせないとバックエンドが大変だから今じゃない。
// 今じゃなかったらいつなんって話だけど。。
// 今後切り替えるとしたら、バックエンド側で両方扱えるようにする期間を作る必要がある。
// APIを2つ用意するか、リクエストパラメータでcredentialを分岐するかの2択。
// リクエストで分岐してみるか。
const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
};

const app = getApps().find(a => a.name === appName) ?? initializeApp(firebaseConfig, appName);

export const getFirebaseApp = () => app;
